import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { AvlTable } from './Table/Table';
import SkeletonComponent from '../SkeletonComponent';
import { UrlActionType, UrlButton } from './UrlButton/UrlButton';

export const Columns = {
    reference: 'Reference',
    kind: 'Kind',
    status: 'Status',
};

export function PurchasesTable({
    records,
    isLoading,
    rowsPerPageDefault = 10,
    hiddenColumns = [],
}) {
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageDefault);
    const pagesCount = Math.ceil(records.length / rowsPerPage);

    const handlePageChange = (event, value) => {
        setPage(value);
    };

    const recordsToShow = records.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const handleChangeRowsPerPagePage = (rowsPerPage) => {
        const initialPage = 1;
        setRowsPerPage(rowsPerPage);
        setPage(initialPage);
    };

    const tableHeaders = [
        {
            label: Columns.reference,
            align: 'left',
        },
        {
            label: Columns.kind,
            align: 'left',
        },
        {
            label: Columns.status,
            align: 'left',
        },
    ].filter((header) => !hiddenColumns.includes(header.label));

    const convertToCells = (row) => [
        {
            isDisabled: hiddenColumns.includes(Columns.reference),
            data: row.reference ? (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div
                        style={{
                            textOverflow: 'ellipsis',
                            overflow: 'hidden',
                            maxWidth: '100px',
                        }}
                    >
                        {row.reference}
                    </div>
                    <UrlButton
                        buttonStyles={{
                            link: { width: '24px', height: '24px' },
                        }}
                        description={`Copy to clipboard "${row.reference}"`}
                        action={UrlActionType.copyToClipboard}
                        url={row.reference}
                    />
                </div>
            ) : (
                'N/A'
            ),
        },
        {
            isDisabled: hiddenColumns.includes(Columns.kind),
            data: row.kind || 'N/A',
        },
        {
            isDisabled: hiddenColumns.includes(Columns.status),
            style: {
                color: row.is_error ? 'red' : 'inherit',
                fontWeight: row.is_error ? 'bold' : 'normal',
            },
            data: row.status || 'NO PURCHASES FOUND',
        },
    ];

    const tableRows = recordsToShow.map((row) => ({
        cells: convertToCells(row),
    }));

    if (isLoading) {
        return <SkeletonComponent />;
    }

    return (
        <div
            style={{
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
            }}
        >
            <AvlTable
                headers={tableHeaders}
                rows={tableRows}
                page={page}
                pageCount={pagesCount}
                rowsPerPage={rowsPerPage}
                rowsCount={records.length}
                onPageChange={handlePageChange}
                onChangeRowsPerPage={handleChangeRowsPerPagePage}
                isRowsPerPageOptionsVisible={true}
            />
        </div>
    );
}

PurchasesTable.propTypes = {
    records: PropTypes.arrayOf(
        PropTypes.shape({
            reference: PropTypes.string,
            kind: PropTypes.string,
            status: PropTypes.string,
            isError: PropTypes.bool,
        })
    ).isRequired,
    isLoading: PropTypes.bool.isRequired,
    rowsPerPageDefault: PropTypes.number,
    hiddenColumns: PropTypes.arrayOf(PropTypes.string),
};

export default PurchasesTable;
